module.exports = __webpack_public_path__ + "static/media/vi-ambientworks.3f5a96e.mp3";


//////////////////
// WEBPACK FOOTER
// ./src/assets/sounds/ambient-works/vi-ambientworks.mp3
// module id = cWRa
// module chunks = 0